// import React, { useState, useEffect, useCallback } from "react";
// import { useNavigate, useLocation, Link } from "react-router-dom";
// import "./Viewer.module.css";
// import logo from "./logo.jpg";
// import Sidebar from "../Sidebar/Sidebar";
// import AutodeskViewer from "../../modules/AutodeskViewer/AutodeskViewer";
// import MultipleModelViewer from "../../modules/AutodeskViewer/MultipleModelViewer";
// import ViewerControls from "../ViewerControls/ViewerControls";
// import StatusMessage from "../../components/StatusMessage";
// import useAutodeskViewer from "../../hooks/useAutodeskViewer";
// import { useAuth } from "../../context/AuthContext";
// import { NestedViewer } from "../viewerExtension/nested-viewer/nested-viewer.ve";
// import { ARLauncher } from "../viewerExtension/ARExxtenshion/AR";
// import { PushpinVEContainer } from "../viewerExtension/Pushpin/index";
// import { IssueSidebarBridge } from "./IssueSidebarBridge";
// import { resolveUserUrnId } from "../../services/issuesApi";
// import { Deff } from "../viewerExtension/deff/compare.aggregated.view";
// export const Viewer = () => {
//   const navigate = useNavigate();
//   const { onLogout } = useAuth();
//   const { search } = useLocation();
//   const params = new URLSearchParams(search);
//   const urn = params.get("urn");
//   const urnIdFromQuery = params.get("urnId");

//   const [documentUrn, setDocumentUrn] = useState("");
//   const [appInitialized, setAppInitialized] = useState(false);
//   const [submitting, setSubmitting] = useState(false);
//   const {
//     accessToken,
//     viewer,
//     status,
//     loading,
//     initializeApp,
//     loadModel,
//     fitToWindow,
//     resetView,
//     toggleFullscreen,
//   } = useAutodeskViewer();

//   useEffect(() => {
//     const initialize = async () => {
//       await initializeApp();
//       setAppInitialized(true);
//     };

//     initialize();
//   }, [initializeApp]);

//   const documentIdForViewer = urn;

//   useEffect(() => {
//     window.__viewstructDocumentUrn = documentIdForViewer || null;
//     let cancelled = false;
//     (async () => {
//       if (!documentIdForViewer) {
//         window.__viewstructUserUrnId = null;
//         return;
//       }
//       if (urnIdFromQuery) {
//         const n = parseInt(urnIdFromQuery, 10);
//         window.__viewstructUserUrnId = Number.isFinite(n) ? n : null;
//         return;
//       }
//       try {
//         const id = await resolveUserUrnId(documentIdForViewer);
//         if (!cancelled) window.__viewstructUserUrnId = id;
//       } catch {
//         if (!cancelled) window.__viewstructUserUrnId = null;
//       }
//     })();
//     return () => {
//       cancelled = true;
//     };
//   }, [documentIdForViewer, urnIdFromQuery]);

//   const handleLoadModel = () => {
//     loadModel(documentUrn);
//   };

//   const handleLoadSampleModel = (model) => {
//     setDocumentUrn(model.urn);
//     loadModel(model.urn);
//   };

//   const handleFileUploaded = (result) => {
//     setDocumentUrn(result.urn);
//     setTimeout(() => {
//       loadModel(result.urn);
//     }, 2000);
//   };

//   const handleLogOut = useCallback(async () => {
//     setSubmitting(true);
//     try {
//       await onLogout();
//       setSubmitting(false);
//       navigate("/");
//     } catch (err) {
//       setSubmitting(false);
//     }
//   }, [onLogout, navigate]);

//   const Autodesk = window["Autodesk"]; // Access the Autodesk object from the window
//   const extensions = {
//     // HandleSelectionExtension: HandleSelectionExtension(Autodesk),
//     NestedViewer: NestedViewer(Autodesk),
//     ARLauncher: ARLauncher(Autodesk),
//     PushpinVEContainer: PushpinVEContainer(Autodesk),
//     // MarkupVE: MarkupVE(),
//     // PushpinExtension: PushpinVEContainer(),
//     ModelDiff: Deff(Autodesk),
//   };
//   if (!appInitialized) {
//     return (
//       <div className="app">
//         <div className="app-loading">
//           <div className="spinner"></div>
//           <h2>Initializing Autodesk Viewer...</h2>
//           <p>Getting access token and setting up viewer...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="container">
//       <header className="app-header">
//         {/* <h1>🏗️ viewStract</h1> */}
//         <Link to="/home">
//           <img src={logo} alt="logo" className="logo" />
//         </Link>
//         <div className="header-status">
//           {accessToken ? (
//             <span className="status-indicator online">
//               <span>🟢</span>
//               <span>Connected</span>
//             </span>
//           ) : (
//             <span className="status-indicator offline">🔴 Disconnected</span>
//           )}

//           <button
//             className="buttoLogOut"
//             disabled={submitting}
//             aria-expanded="false"
//             aria-haspopup="true"
//             onClick={handleLogOut}
//           >
//             Sign-out
//           </button>
//         </div>
//       </header>
//       <div className="app-content">
//         <Sidebar
//           documentUrn={documentUrn}
//           setDocumentUrn={setDocumentUrn}
//           accessToken={accessToken}
//           loading={loading}
//           onLoadModel={handleLoadModel}
//           onLoadSampleModel={handleLoadSampleModel}
//           onFileUploaded={handleFileUploaded}
//         />

//         <main className="viewer-container">
//           {viewer && (
//             <ViewerControls
//               onFitToWindow={fitToWindow}
//               onResetView={resetView}
//               onToggleFullscreen={toggleFullscreen}
//             />
//           )}

//           <div style={{ width: "100%", height: "100%" }}>
//             {!documentUrn ? (
//               <div className="empty-state">
//                 <div className="empty-state-icon">🏗️</div>
//                 <h3>Ready to Load 3D Models</h3>
//                 <p>Upload a CAD file or select a sample model to get started</p>
//               </div>
//             ) : !accessToken ? (
//               <div className="empty-state">
//                 <div className="empty-state-icon">🔐</div>
//                 <h3>Authentication Required</h3>
//                 <p>Setting up Forge authentication...</p>
//               </div>
//             ) : (
//               <>
//                 <AutodeskViewer
//                   extensions={extensions}
//                   documentId={documentIdForViewer}
//                   accessToken={accessToken}
//                   loading={loading}
//                 />
//                 <MultipleModelViewer />
//                 <IssueSidebarBridge />
//               </>
//             )}
//           </div>
//         </main>
//       </div>
//     </div>
//   );
// };

import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import "./Viewer.module.css";
import logo from "./logo.jpg";
import Sidebar from "../Sidebar/Sidebar";
import AutodeskViewer from "../../modules/AutodeskViewer/AutodeskViewer";
import MultipleModelViewer from "../../modules/AutodeskViewer/MultipleModelViewer";
import ViewerControls from "../ViewerControls/ViewerControls";
import StatusMessage from "../../components/StatusMessage";
import useAutodeskViewer from "../../hooks/useAutodeskViewer";
import { useAuth } from "../../context/AuthContext";
import { NestedViewer } from "../viewerExtension/nested-viewer/nested-viewer.ve";
import { ARLauncher } from "../viewerExtension/ARExxtenshion/AR";
import { PushpinVEContainer } from "../viewerExtension/Pushpin/index";
import { IssueSidebarBridge } from "./IssueSidebarBridge";
import { resolveUserUrnId } from "../../services/issuesApi";

export const Viewer = () => {
  const navigate = useNavigate();
  const { onLogout } = useAuth();
  const { search } = useLocation();
  const params = new URLSearchParams(search);

  // Ստուգել URL-ի պարամետրերը
  const urn = params.get("urn");
  const urn1 = params.get("urn1");
  const urn2 = params.get("urn2");
  const urnIdFromQuery = params.get("urnId");

  const [documentUrn, setDocumentUrn] = useState("");
  const [appInitialized, setAppInitialized] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  // Որոշել թե քանի մոդել պետք է բեռնվի
  const isMultiModel = urn1 && urn2; // Երկու մոդել
  const isSingleModel = urn && !urn1 && !urn2; // Մեկ մոդել

  // Multi-model-ի համար մոդելների ցուցակ
  const [multiModels, setMultiModels] = useState([]);

  const {
    accessToken,
    viewer,
    status,
    loading,
    initializeApp,
    loadModel,
    fitToWindow,
    resetView,
    toggleFullscreen,
  } = useAutodeskViewer();

  useEffect(() => {
    const initialize = async () => {
      await initializeApp();
      setAppInitialized(true);
    };
    initialize();
  }, [initializeApp]);

  // Կազմել մոդելների ցուցակը multi-model-ի դեպքում
  useEffect(() => {
    if (isMultiModel && urn1 && urn2) {
      const models = [];
      if (urn1) models.push({ urn: urn1 });
      if (urn2) models.push({ urn: urn2 });
      setMultiModels(models);
    }
  }, [urn1, urn2, isMultiModel]);

  const documentIdForViewer = urn;

  useEffect(() => {
    window.__viewstructDocumentUrn = documentIdForViewer || null;
    let cancelled = false;
    (async () => {
      if (!documentIdForViewer) {
        window.__viewstructUserUrnId = null;
        return;
      }
      if (urnIdFromQuery) {
        const n = parseInt(urnIdFromQuery, 10);
        window.__viewstructUserUrnId = Number.isFinite(n) ? n : null;
        return;
      }
      try {
        const id = await resolveUserUrnId(documentIdForViewer);
        if (!cancelled) window.__viewstructUserUrnId = id;
      } catch {
        if (!cancelled) window.__viewstructUserUrnId = null;
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [documentIdForViewer, urnIdFromQuery]);

  const handleLoadModel = () => {
    loadModel(documentUrn);
  };

  const handleLoadSampleModel = (model) => {
    setDocumentUrn(model.urn);
    loadModel(model.urn);
  };

  const handleFileUploaded = (result) => {
    setDocumentUrn(result.urn);
    setTimeout(() => {
      loadModel(result.urn);
    }, 2000);
  };

  const handleLogOut = useCallback(async () => {
    setSubmitting(true);
    try {
      await onLogout();
      setSubmitting(false);
      navigate("/");
    } catch (err) {
      setSubmitting(false);
    }
  }, [onLogout, navigate]);

  const Autodesk = window["Autodesk"];
  const extensions = {
    NestedViewer: NestedViewer(Autodesk),
    ARLauncher: ARLauncher(Autodesk),
    // deff:
    PushpinVEContainer: PushpinVEContainer(Autodesk),
  };

  if (!appInitialized) {
    return (
      <div className="app">
        <div className="app-loading">
          <div className="spinner"></div>
          <h2>Initializing Autodesk Viewer...</h2>
          <p>Getting access token and setting up viewer...</p>
        </div>
      </div>
    );
  }

  // Որոշել թե ինչ ցույց տալ
  const renderViewerContent = () => {
    // Եթե բեռնված չէ accessToken
    if (!accessToken) {
      return (
        <div className="empty-state">
          <div className="empty-state-icon">🔐</div>
          <h3>Authentication Required</h3>
          <p>Setting up Forge authentication...</p>
        </div>
      );
    }

    // Երկու մոդելի դեպքում
    if (isMultiModel && multiModels.length === 2) {
      return (
        <>
          <MultipleModelViewer
            models={multiModels}
            accessToken={accessToken}
            onError={(err) => console.error("Multi-model error:", err)}
            onModelsLoaded={(bubbles) => console.log("Models loaded:", bubbles)}
          />
          <IssueSidebarBridge />
        </>
      );
    }

    // Մեկ մոդելի դեպքում
    if (isSingleModel && documentIdForViewer) {
      return (
        <>
          <AutodeskViewer
            extensions={extensions}
            documentId={documentIdForViewer}
            accessToken={accessToken}
            loading={loading}
            onError={(err) => console.error("Viewer error:", err)}
            onDocumentLoaded={(doc) => console.log("Document loaded:", doc)}
          />
          <IssueSidebarBridge />
        </>
      );
    }

    // Եթե ոչ մի մոդել ընտրված չէ
    return (
      <div className="empty-state">
        <div className="empty-state-icon">🏗️</div>
        <h3>Ready to Load 3D Models</h3>
        <p>Upload a CAD file or select a sample model to get started</p>
      </div>
    );
  };

  return (
    <div className="container">
      {/* <header className="app-header">
        <Link to="/home">
          <img src={logo} alt="logo" className="logo" />
        </Link>
        <div className="header-status">
          {accessToken ? (
            <span className="status-indicator online">
              <span>🟢</span>
              <span>Connected</span>
            </span>
          ) : (
            <span className="status-indicator offline">🔴 Disconnected</span>
          )}
          <button
            className="buttoLogOut"
            disabled={submitting}
            onClick={handleLogOut}
          >
            Sign-out
          </button>
        </div>
      </header> */}
      <div className="app-content">
        <Sidebar
          documentUrn={documentUrn}
          setDocumentUrn={setDocumentUrn}
          accessToken={accessToken}
          loading={loading}
          onLoadModel={handleLoadModel}
          onLoadSampleModel={handleLoadSampleModel}
          onFileUploaded={handleFileUploaded}
        />

        <main className="viewer-container">
          {/* Viewer Controls - միայն մեկ մոդելի դեպքում */}
          {isSingleModel && viewer && (
            <ViewerControls
              onFitToWindow={fitToWindow}
              onResetView={resetView}
              onToggleFullscreen={toggleFullscreen}
            />
          )}

          <div style={{ width: "100%", height: "100%" }}>
            {renderViewerContent()}
          </div>
        </main>
      </div>
    </div>
  );
};
